import { EnvValue } from 'app/services/env.service/EnvValue.type';

export function getEnvStringValue(valueFromEnv: EnvValue) {
  if (valueFromEnv === undefined) {
    console.warn('Invalid env value.');
  }

  return valueFromEnv;
}
